"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var fs_1 = __importDefault(require("fs"));

var util_1 = __importDefault(require("util"));

var error_1 = require("./error");

var isnode_1 = __importDefault(require("./isnode"));

var fsprom;

if (isnode_1.default) {
  fsprom = util_1.default.promisify(fs_1.default.readFile);
}

var Las =
/*#__PURE__*/
function () {
  _createClass(Las, null, [{
    key: "chunk",
    value: function chunk(arr, size) {
      var overall = [];
      var index = 0;

      while (index < arr.length) {
        overall.push(arr.slice(index, index + size));
        index += size;
      }

      return overall;
    }
  }, {
    key: "removeComment",
    value: function removeComment(str) {
      return str.trim().split('\n').map(function (val) {
        return val.trimLeft();
      }).filter(function (f) {
        return !(f.charAt(0) === '#');
      }).join('\n');
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(s) {
      return Boolean(+s) || /^0|0$/.test(s) ? +s : s;
    }
    /**
     * Creates an instance of Las.
     * @param {string} path - Absolute path to las file
     * @memberof Las
     */

  }]);

  function Las(path) {
    _classCallCheck(this, Las);

    this.path = path;
    this.blobString = this.initialize();
  }
  /**
   * Returns a column in a las file
   * @param {string} column - name of column
   * @returns {(Promise<Array<string| number>>)}
   * @memberof Las
   */


  _createClass(Las, [{
    key: "column",
    value: function column(_column) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var hds, sB, index;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.header();

              case 2:
                hds = _context.sent;
                _context.next = 5;
                return this.data();

              case 5:
                sB = _context.sent;
                index = hds.findIndex(function (item) {
                  return item.toLowerCase() === _column.toLowerCase();
                });

                if (!(index < 0)) {
                  _context.next = 9;
                  break;
                }

                throw new error_1.ColumnError(_column);

              case 9:
                return _context.abrupt("return", sB.map(function (c) {
                  return c[index];
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Returns a column in a las file stripped off null values
     * @param {string} column - name of column
     * @returns {(Promise<Array<string| number>>)}
     * @memberof Las
     */

  }, {
    key: "columnStripped",
    value: function columnStripped(column) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var hds, sB, index;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.header();

              case 2:
                hds = _context2.sent;
                _context2.next = 5;
                return this.dataStripped();

              case 5:
                sB = _context2.sent;
                index = hds.findIndex(function (item) {
                  return item.toLowerCase() === column.toLowerCase();
                });

                if (!(index >= 0)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", sB.map(function (c) {
                  return c[index];
                }));

              case 11:
                throw new error_1.ColumnError(column);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Returns a csv File object in browser | writes csv file to current working driectory in Node
     * @param {string} filename
     * @returns {(Promise<File | void>)}
     * @memberof Las
     */

  }, {
    key: "toCsv",
    value: function toCsv() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'file';
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var headers, data, rHd, rData, file;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.header();

              case 3:
                headers = _context3.sent;
                _context3.next = 6;
                return this.data();

              case 6:
                data = _context3.sent;
                rHd = headers.join(',') + '\n';
                rData = data.map(function (d) {
                  return d.join(',');
                }).join('\n');

                if (!isnode_1.default) {
                  _context3.next = 13;
                  break;
                }

                fs_1.default.writeFile("".concat(filename, ".csv"), rHd + rData, 'utf8', function (err) {
                  if (err) {
                    throw new error_1.CsvError();
                  }

                  console.log("".concat(filename, ".csv has been saved to current working directory"));
                });
                _context3.next = 15;
                break;

              case 13:
                file = new File([rHd + rData], "".concat(filename, ".csv"));
                return _context3.abrupt("return", file);

              case 15:
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](0);
                throw new error_1.CsvError();

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 17]]);
      }));
    }
    /**
     * Returns a csv File object in browser and writes csv file to current working driectory in Node of data stripped of null values
     * @param {string} filename
     * @returns {(Promise<File | void>)}
     * @memberof Las
     */

  }, {
    key: "toCsvStripped",
    value: function toCsvStripped() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'file';
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var headers, data, rHd, rData, file;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.header();

              case 3:
                headers = _context4.sent;
                _context4.next = 6;
                return this.dataStripped();

              case 6:
                data = _context4.sent;
                rHd = headers.join(',') + '\n';
                rData = data.map(function (d) {
                  return d.join(',');
                }).join('\n');

                if (isnode_1.default) {
                  _context4.next = 12;
                  break;
                }

                file = new File([rHd + rData], "".concat(filename, ".csv"));
                return _context4.abrupt("return", file);

              case 12:
                fs_1.default.writeFile("".concat(filename, ".csv"), rHd + rData, 'utf8', function (err) {
                  if (err) {
                    throw new error_1.CsvError();
                  }

                  console.log("".concat(filename, ".csv has been saved to current working directory"));
                });
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](0);
                throw new error_1.CsvError();

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 15]]);
      }));
    }
    /**
     * Returns the number of rows in a .las file
     * @returns number
     * @memberof Las
     */

  }, {
    key: "rowCount",
    value: function rowCount() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var l;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.data();

              case 2:
                l = _context5.sent;
                return _context5.abrupt("return", l.length);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
    /**
     * Returns the number of columns in a .las file
     * @returns number
     * @memberof Las
     */

  }, {
    key: "columnCount",
    value: function columnCount() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var l;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.header();

              case 2:
                l = _context6.sent;
                return _context6.abrupt("return", l.length);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
    /**
     * Returns a two-dimensional array of data in the log
     * @returns {(Promise<Array<Array<string | number>>>)}
     * @memberof Las
     */

  }, {
    key: "data",
    value: function data() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var s, hds, totalheadersLength, sB, con;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.blobString;

              case 2:
                s = _context7.sent;
                _context7.next = 5;
                return this.header();

              case 5:
                hds = _context7.sent;
                totalheadersLength = hds.length;
                sB = s.split(/~A(?:\w*\s*)*\n/)[1].trim().split(/\s+/).map(function (m) {
                  return Las.convertToValue(m.trim());
                });

                if (!(sB.length < 0)) {
                  _context7.next = 10;
                  break;
                }

                throw new error_1.LasError('No data/~A section in the file');

              case 10:
                con = Las.chunk(sB, totalheadersLength);
                return _context7.abrupt("return", con);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
    /**
     * Returns a two-dimensional array of data in the log with all rows containing null values stripped off
     * @returns {(Promise<Array<Array<string | number>>>)}
     * @memberof Las
     */

  }, {
    key: "dataStripped",
    value: function dataStripped() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var s, hds, well, nullValue, totalheadersLength, sB, con, filtered;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.blobString;

              case 2:
                s = _context8.sent;
                _context8.next = 5;
                return this.header();

              case 5:
                hds = _context8.sent;
                _context8.next = 8;
                return this.property('well');

              case 8:
                well = _context8.sent;
                nullValue = well.NULL.value;
                totalheadersLength = hds.length;
                sB = s.split(/~A(?:\w*\s*)*\n/)[1].trim().split(/\s+/).map(function (m) {
                  return Las.convertToValue(m.trim());
                });

                if (!(sB.length < 0)) {
                  _context8.next = 14;
                  break;
                }

                throw new error_1.LasError('No data/~A section in the file');

              case 14:
                con = Las.chunk(sB, totalheadersLength);
                filtered = con.filter(function (f) {
                  return !f.some(function (x) {
                    return x === +nullValue;
                  });
                });
                return _context8.abrupt("return", filtered);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
    /**
     * Returns the version number of the las file
     * @returns {Promise<number>}
     * @memberof Las
     */

  }, {
    key: "version",
    value: function version() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var v;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.metadata();

              case 2:
                v = _context9.sent;
                return _context9.abrupt("return", v[0]);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
    /**
     * Returns true if the las file is of wrapped variant and false otherwise
     * @returns {Promise<boolean>}
     * @memberof Las
     */

  }, {
    key: "wrap",
    value: function wrap() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var v;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.metadata();

              case 2:
                v = _context10.sent;
                return _context10.abrupt("return", v[1]);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Returns an extra info about the well stored in ~others section
     * @returns {Promise<string>}
     * @memberof Las
     */

  }, {
    key: "other",
    value: function other() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var s, som, str, some;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.blobString;

              case 2:
                s = _context11.sent;
                som = s.split(/~O(?:\w*\s*)*\n\s*/i)[1];
                str = '';

                if (som) {
                  some = som.split('~')[0].replace(/\n\s*/g, ' ').trim();
                  str = Las.removeComment(some);
                }

                if (!(str.length <= 0)) {
                  _context11.next = 8;
                  break;
                }

                throw new error_1.LasError('No ~other section');

              case 8:
                return _context11.abrupt("return", str);

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
    /**
     * Returns an array of strings of the logs header/title
     * @returns {Promise<string[]>}
     * @memberof Las
     */

  }, {
    key: "header",
    value: function header() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var s, sth, uncommentedSth;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.blobString;

              case 2:
                s = _context12.sent;
                sth = s.split(/~C(?:\w*\s*)*\n\s*/)[1].split('~')[0];
                uncommentedSth = Las.removeComment(sth).trim();

                if (!(uncommentedSth.length < 0)) {
                  _context12.next = 7;
                  break;
                }

                throw new error_1.LasError('There is no header in the file');

              case 7:
                return _context12.abrupt("return", uncommentedSth.split('\n').map(function (m) {
                  return m.trim().split(/\s+|[.]/)[0];
                }));

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
    /**
     * Returns an object, each well header and description as a key-value pair
     * @returns {Promise<{[key:string]: string}>}
     * @memberof Las
     */

  }, {
    key: "headerAndDescr",
    value: function headerAndDescr() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var cur, hd, descr, obj;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.property('curve');

              case 2:
                cur = _context13.sent;
                hd = Object.keys(cur);
                descr = Object.values(cur).map(function (c, i) {
                  return c.description === 'none' ? hd[i] : c.description;
                });
                obj = {};
                hd.map(function (_, i) {
                  return obj[hd[i]] = descr[i];
                });

                if (!(Object.keys(obj).length < 0)) {
                  _context13.next = 9;
                  break;
                }

                throw new error_1.LasError('Poorly formatted ~curve section in the file');

              case 9:
                return _context13.abrupt("return", obj);

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Returns details of  well parameters.
     * @returns {Promise<WellProps>}
     * @memberof Las
     */

  }, {
    key: "wellParams",
    value: function wellParams() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.property('well'));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
    /**
     * Returns details of  curve parameters.
     * @returns {Promise<WellProps>}
     * @memberof Las
     */

  }, {
    key: "curveParams",
    value: function curveParams() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.property('curve'));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
    /**
     * Returns details of  parameters of the well.
     * @returns {Promise<WellProps>}
     * @memberof Las
     */

  }, {
    key: "logParams",
    value: function logParams() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.property('param'));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "metadata",
    value: function metadata() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        var str, sB, sw, refined, res, wrap;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.blobString;

              case 2:
                str = _context17.sent;
                sB = str.trim().split(/~V(?:\w*\s*)*\n\s*/)[1].split(/~/)[0];
                sw = Las.removeComment(sB);
                refined = sw.split('\n').map(function (m) {
                  return m.split(/\s{2,}|\s*:/).slice(0, 2);
                }).filter(function (f) {
                  return Boolean(f);
                });
                res = refined.map(function (r) {
                  return r[1];
                });
                wrap = res[1].toLowerCase() === 'yes' ? true : false;

                if (!([+res[0], wrap].length < 0)) {
                  _context17.next = 10;
                  break;
                }

                throw new error_1.LasError("Couldn't get metadata");

              case 10:
                return _context17.abrupt("return", [+res[0], wrap]);

              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "property",
    value: function property(p) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18() {
        var regDict, regExp, str, substr, sw, res, s;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                regDict = {
                  curve: '~C(?:\\w*\\s*)*\\n\\s*',
                  param: '~P(?:\\w*\\s*)*\\n\\s*',
                  well: '~W(?:\\w*\\s*)*\\n\\s*'
                };
                regExp = new RegExp(regDict[p], 'i');
                _context18.next = 4;
                return this.blobString;

              case 4:
                str = _context18.sent;
                substr = str.split(regExp);
                sw = '';

                if (substr.length > 1) {
                  res = substr[1].split(/~/)[0];
                  sw = Las.removeComment(res);
                }

                if (!(sw.length > 0)) {
                  _context18.next = 14;
                  break;
                }

                s = {};
                sw.split('\n').map(function (c) {
                  var obj = c.replace(/\s*[.]\s+/, '   none   ');
                  var title = obj.split(/[.]|\s+/)[0];
                  var unit = obj.trim().split(/^\w+\s*[.]*s*/)[1].split(/\s+/)[0];
                  var description = Boolean(obj.split(/[:]/)[1].trim()) ? obj.split(/[:]/)[1].trim() : 'none';
                  var third = obj.split(/[:]/)[0].split(/\s{2,}\w*\s{2,}/);
                  var value = third.length > 2 && !Boolean(third[third.length - 1]) ? third[third.length - 2] : third[third.length - 1];
                  value = value.length > 0 ? value.trim() : value;
                  s[title] = {
                    unit: unit,
                    value: value,
                    description: description
                  };
                });
                return _context18.abrupt("return", s);

              case 14:
                throw new error_1.PropertyError(p);

              case 15:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "initialize",
    value: function initialize() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var _this = this;

        var str, val, text;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!isnode_1.default) {
                  _context19.next = 13;
                  break;
                }

                _context19.prev = 1;
                _context19.next = 4;
                return fsprom(this.path, 'utf8');

              case 4:
                str = _context19.sent;
                return _context19.abrupt("return", str);

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](1);
                throw new error_1.PathError();

              case 11:
                _context19.next = 32;
                break;

              case 13:
                if (!(this.path instanceof File)) {
                  _context19.next = 17;
                  break;
                }

                return _context19.abrupt("return", new Promise(function (resolve, reject) {
                  var reader = new FileReader();

                  reader.onerror = function () {
                    reject(new error_1.PathError());
                  };

                  reader.onload = function () {
                    resolve(reader.result);
                  };

                  reader.readAsText(_this.path);
                }));

              case 17:
                _context19.prev = 17;
                _context19.next = 20;
                return fetch(this.path);

              case 20:
                val = _context19.sent;
                _context19.next = 23;
                return val.text();

              case 23:
                text = _context19.sent;

                if (!text.includes('404: Not Found')) {
                  _context19.next = 26;
                  break;
                }

                throw new error_1.PathError();

              case 26:
                return _context19.abrupt("return", text);

              case 29:
                _context19.prev = 29;
                _context19.t1 = _context19["catch"](17);
                throw new error_1.PathError();

              case 32:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[1, 8], [17, 29]]);
      }));
    }
  }]);

  return Las;
}();

exports.Las = Las;